<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="green"
        dark
        v-bind="attrs"
        v-on="on"
      >
        Прикрепить договор
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Прикрепить договор к заявлению №{{application.id}}</span>
      </v-card-title>
      <v-card-text>
        <file-input
          ref="typeFiles"
          :multiple=true
          :type="100"
          :application="application">
        </file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialog = false">Отправить</v-btn>
        <v-btn color="red darken-1" text @click="dialog = false">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import FileInput from "../profile/FileInput";

  export default {
    name: "send_contract",
    data: () => ({
      dialog: false,
    }),
    props: ['application'],
    components: {FileInput},
    watch: {
      dialog(newValue) {
        if (newValue) {
          this.$store.dispatch("filemanager/loadUploadedFilesByApplication", this.application.id)
        }
      },
    },
  }
</script>

<style scoped>

</style>
